<template>
  <div
    v-if="name !== '' && music !== '' && speed !== ''"
    class="tile"
    :class="[
      index === 0 || index === 5 ? 'tile-1' : '',
      index === 1 ? 'tile-2' : '',
      index === 3 ? 'tile-4' : '',
      index === 2 || index === 4 ? 'tile-3' : ''
    ]"
  >
    <div class="name">{{ name }}</div>
    <div class="music"><MusicIcon title="" /> {{ music }}</div>
    <div class="speed"><SpeedIcon title="" /> {{ mappedSpeed }}</div>
    <div class="actions">
      <EditIcon title="editieren" class="edit" @click="selectAndEmit" />
      <TrashIcon title="löschen" class="delete" @click="selectAndDelete" />
    </div>
  </div>
  <div v-else class="tile idle" @click="selectAndEmit">
    <div>
      Hier ist noch Platz für eine Strecke
    </div>
    <div class="icon"><PlusIcon title="Neu..." /></div>
  </div>
</template>

<script>
import MusicIcon from "vue-material-design-icons/Music";
import SpeedIcon from "vue-material-design-icons/Speedometer";
import TrashIcon from "vue-material-design-icons/TrashCanOutline";
import EditIcon from "vue-material-design-icons/Pencil";
import PlusIcon from "vue-material-design-icons/PlusCircle";
import { mapActions } from "vuex";

export default {
  name: "ConfigTile",
  components: {
    MusicIcon,
    SpeedIcon,
    TrashIcon,
    EditIcon,
    PlusIcon
  },
  props: {
    name: { type: String, default: "" },
    music: { type: String, default: "" },
    speed: { type: String, default: "" },
    index: { type: Number, default: 0 }
  },
  data() {
    return {
      mappedSpeed: ""
    };
  },
  watch: {
    speed: {
      handler: function(newVal) {
        let median = parseInt(newVal);
        if (!isNaN(median)) {
          median = median / 6;
          if (median < 2) {
            this.mappedSpeed = "sehr schnell";
          } else if (median >= 2 && median < 4) {
            this.mappedSpeed = "schnell";
          } else if (median >= 4 && median < 8) {
            this.mappedSpeed = "normal";
          } else if (median >= 8 && median < 14) {
            this.mappedSpeed = "langsam";
          } else {
            this.mappedSpeed = "sehr langsam";
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions("configurations", ["selectConfigForEdit"]),
    async selectAndEmit() {
      await this.selectConfigForEdit(this.index);
      this.$emit("select");
    },
    async selectAndDelete() {
      await this.selectConfigForEdit(this.index);
      this.$emit("delete");
    }
  }
};
</script>

<style scoped>
.tile {
  -webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
  height: 100px;
  width: 320px;
  position: relative;
  margin: 20px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: left top;
}

.tile.idle {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: 2px dotted #0178b7;
  background: #0b2137;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tile.idle:hover {
  background: rgba(1, 120, 183, 0.1);
  cursor: pointer;
}

.idle .icon {
  margin-left: 10px;
  color: #00a7ff;
}

.name {
  position: absolute;
  left: 30px;
  top: 20px;
  font-size: 1.3rem;
}

.music,
.speed {
  position: absolute;
  bottom: 15px;
  font-size: 0.8rem;
}

.music {
  left: 20px;
}

.speed {
  right: 20px;
}

.actions {
  position: absolute;
  right: 20px;
  top: 25px;
}

.edit {
  padding-right: 10px;
}

.edit:hover {
  cursor: pointer;
  color: #00a7ff;
}

.delete:hover {
  cursor: pointer;
  color: #e24f4f;
}

.tile-1 {
  background-image: url("../assets/tile_blue.png");
}

.tile-2 {
  background-image: url("../assets/tile_green.png");
}

.tile-3 {
  background-image: url("../assets/tile_violet.png");
}

.tile-4 {
  background-image: url("../assets/tile_lightblue.png");
}
</style>
